$(document).ready(function(){

  var isALARendered;

  function ALAcheck() {
    isALARendered = setInterval(function () {
      customALA();
    }, 200);
  }

  ALAcheck();

  function customALA() {
    var selector = $('.addon-product');

    if(selector.length > 0) {
      $(".addon-product").each(function(){
        $(this).find("h4").on("click", function(){
          $("h4").removeClass("active");
          $(this).addClass("active");
          $("body").addClass("custom_drwer");
          $(".addon-product").find(".custom_drawer").addClass("hidden");
          $(this).closest(".addon-product").find(".custom_drawer").removeClass("hidden");
        });
      });

      $(document).on('change', '.bundleCheck', function () {
        const $group = $(this).closest('ul[name="addon-variant"]');

        // Reset all buttons in group
        $group.find('li').removeClass('checked').each(function () {
          const defaultPrice = $(this).find('.button--block').attr("data-price") || "Free";

          $(this).find('.without_addon').text("Choose | Free");
          $(this).find('.with_addon').text("Choose | " + defaultPrice);
        });

        const $currentLi = $(this).closest('li');

        $currentLi.addClass('checked');

        const selectedTitle = $currentLi.attr('data-vTitle');

        $(".block-swatch.s_variant.active").text(selectedTitle);

        $currentLi.find('.without_addon').text("selected");
        $currentLi.find('.with_addon').text("selected ");
      });
    }
  }


  $(document).on('click', '.button--block', function () {
    const $this = $(this);

    if ($this.text().trim().includes("Choose")) {
      cloase_drawer();
    }

    const $radio = $this.siblings('input[type="radio"]');

    $radio.prop('checked', true).trigger('change');
  });


  function cloase_drawer(){
    $(".addon-product").find(".custom_drawer").each(function(){
      $(this).addClass("hidden");
      $("body").removeClass("custom_drwer");
      $(".block-swatch").removeClass("custom_drwer");
    });
  }


  $(document).on("click", '.close-icon', function(){
    cloase_drawer();
  });


  $(document).on("click", '.bg-overlay', function(){
    cloase_drawer();
  });


  // atc bundle

  // $('.template-multi_product form.shopify-product-form .buy-buttons button').on('click', function(e) {
  $('form.shopify-product-form .buy-buttons button').on('click', function(e) {
    e.preventDefault();

    const $addToCartButton = $(this);
    $addToCartButton.addClass('loading').prop('disabled', true);

    console.log("btn_click");

    var timestemp = Date.now();

    var items = [];

    $('ul[name="addon-variant"]').each(function() {
      const selectedRadio = $(this).find('li.checked input.bundleCheck');

      if (selectedRadio.length > 0) {
        const variantId = parseInt(selectedRadio.data('vid'));
        const variantLabel = $(this).parents(".addon-product").data('vtitle');
        const variantTitle = selectedRadio.data('value');
        const quantity = 1;

        // Add separate addon product
        items.push({
          id: variantId,
          quantity: quantity,
          properties: {
            _addon: "free",
            _bundle_group_id: timestemp,
            _is_addon: true
          }
        });
      }
    });


    // const mainVariant = parseInt($('.template-multi_product form.shopify-product-form [name="id"]').val());
    const mainVariant = parseInt($('form.shopify-product-form [name="id"]').val());

    const mainQty = 1;


    // let addonProperties = {};
    // let addonIndex = -1;
    // let usedLabels = new Set();

    // $('.addon-product').each(function(index) {
    //   let pro_label = $(this).data("vtitle")?.trim();
    //   const pro_val = $(this).find(".block-swatch.s_variant").text().trim();

    //   // Generate a label if missing or already used
    //   if (!pro_label || usedLabels.has(pro_label)) {
    //     pro_label = `Addon ${addonIndex}`;
    //   }

    //   // Store in properties
    //   addonProperties[pro_label] = pro_val;

    //   // Track used labels
    //   usedLabels.add(pro_label);
    //   addonIndex++;
    // });


    let addonProperties = {};
    let addonIndex = 1;
    let usedLabels = new Set();

    $('.addon-product').each(function(index) {
      let pro_label;

      if ($(this).closest('.birthstone-bracelet').length) {
        pro_label = $(this).find(".block-swatch-title").text().trim();
      } else {
        // let pro_label = $(this).data("vtitle")?.trim();
        pro_label = $(this).data("addon-label")?.trim();
      }

      const pro_val = $(this).find(".block-swatch.s_variant").text().trim();

      // If label missing OR duplicate → generate Addon label
      if (!pro_label || usedLabels.has(pro_label)) {
        pro_label = `Addon ${addonIndex}`;
        usedLabels.add(pro_label);
        addonIndex++;
      } else {
        usedLabels.add(pro_label);
      }

      addonProperties[pro_label] = pro_val;
    });


    console.log("addonProperties:--", addonProperties);
    console.log("mainQty:--", mainQty);
    console.log("mainVariant:--", mainVariant);


    if (mainVariant && mainQty > 0) {
      items.unshift({
        id: mainVariant,
        quantity: mainQty,
        properties: {
          ...addonProperties,
          _bundle_group_id: timestemp,
          _is_main: true
        }
      });
    }


    console.log("Final items to add:", items);


    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ items })
    })
    .then(res => res.json())
    .then(data => {
      console.log('Added to cart:', data);

      document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:open'));

      const checkoutButton = document.querySelector('a[href="/cart"]');

      const clickEvent = new MouseEvent('click', {
        bubbles: true,
        cancelable: true,
        view: window
      });

      setTimeout(function(){
        checkoutButton.dispatchEvent(clickEvent);
      }, 1500);
      $addToCartButton.removeClass('loading').prop('disabled', false);
    })
    .catch(err => {
      console.error('Error adding to cart:', err);

      // Hide loader if request fails
      $addToCartButton.removeClass('loading').prop('disabled', false);
    });
  });


  const maxAddonValues = document.querySelector(".max-add-on-items").value;
  const maxInitial = maxAddonValues || 3;


  // Add Initial block
  $(".add_more_initial").on("click", function () {
    const currentInitials = $(".pro_1").length;

    if (currentInitials < maxInitial) {
      const newBlock = $(".pro_1").first().clone(true, true);

      newBlock.find(".button--block").each(function () {
        const price = $(this).attr("data-price") || "Free";

        $(this).find(".without_addon").text("Choose | Free");
        $(this).find(".with_addon").text("Choose | " + price);
      });


      // Add remove button if not already present
      if (newBlock.find(".remove-addon").length === 0) {
        newBlock.append(
          '<button class="remove-addon" type="button" style="position:absolute; top:5px; right:5px; background:transparent; border:none; font-size:18px; cursor:pointer;">×</button>'
        );

        newBlock.css("position", "relative");
      }


      // Append the new block
      newBlock.appendTo(".addon_main_pro_2");


      // Hide add button if max reached
      if ($(".pro_1").length >= maxInitial) {
        $(".add_more_initial").hide();
      }
    }
  });


  // Remove Initial block
  $(document).on("click", ".remove-addon", function () {

    const $addonBlock = $(this).closest(
      ".pro_1, .pro_3, .pro_4, .pro_5, .pro_6, .pro_7, .pro_8, .pro_9, .pro_10"
    );

    if ($addonBlock.length) {
      $addonBlock.remove();
    }

    // Re-show add button if under limit
    if ($(".pro_1").length < maxInitial) {
      $(".add_more_initial").show();
    }
  });



  $(".add_more_birthstone").on("click", function () {
    const currentInitials = $(".pro_2").length;

    if (currentInitials < maxInitial) {
      const newBlock = $(".pro_2").first().clone(true, true);

      console.log("newBlock:----", newBlock);

      newBlock.find(".button--block").each(function () {
        const price = $(this).attr("data-price") || "Free";

        $(this).find(".without_addon").text("Choose | Free");
        $(this).find(".with_addon").text("Choose | " + price);
      });


      // Add remove button if not already present
      if (newBlock.find(".remove-addon-sec").length === 0) {
        newBlock.append(
          '<button class="remove-addon-sec" type="button" style="position:absolute; top:5px; right:5px; background:transparent; border:none; font-size:18px; cursor:pointer;">×</button>'
        );

        newBlock.css("position", "relative");
      }


      // Append the new block
      newBlock.appendTo(".addon_main_pro_2");


      // Hide add button if max reached
      if ($(".pro_2").length >= maxInitial) {
        $(".add_more_birthstone").hide();
      }
    }
  });


  // Remove Initial block
  $(document).on("click", ".remove-addon-sec", function () {
    $(this).closest(".pro_2").remove();

    // Re-show add button if under limit
    if ($(".pro_2").length < maxInitial) {
      $(".add_more_birthstone").show();
    }
  });

});